import { render, staticRenderFns } from "./DocumentByUserComponent.vue?vue&type=template&id=5597df3f&"
import script from "./DocumentByUserComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentByUserComponent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentByUserComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports